<template>
  <div>
    <div id="footer" class="footer">
      <div class="wrap-lg">
        <span>© {{year}} SGS SA</span>
        <a rel="nofollow" target="_blank" href="http://beian.miit.gov.cn">京ICP备16004943号-4</a>
        <a rel="nofollow" target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024895">
          <i class="icon"></i>
          <span>京公网安备 11010802024895号</span>
        </a>
        <a rel="nofollow" target="_blank"
          href="https://www.sgsonline.com.cn/static/upload/2019/09/10/1tif.png">增值电信业务经营许可证合字B2-20190019</a>
        <a rel="nofollow" target="_blank" href="https://www.sgsgroup.com.cn/zh-cn/privacy-at-sgs">隐私政策</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortalCopyright',
  props: {},
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  methods: {},
  mounted() { },
}
</script>

<style lang='scss'>
@import './../../assets/style/mixin.scss';

.footer {
  background: #111111;
  padding: 23px 0 57px 0;

  .wrap-lg {
    width: 1226px;
    margin: 0 auto;
  }

  a,
  span {
    font-size: 14px;
    color: #464646;
  }

  a {
    padding-left: 34px;

    &:hover,
    &:hover span {
      color: $mainColor;
    }

    i {
      display: inline-block;
      width: 13px;
      height: 13px;
      background-image: url(./../../assets/images/portal/gaicon.png);
      background-size: cover;
    }
  }
}
</style>